import { transportRequest } from '@krp/client-runtime'
import { AQSI_URLS } from '../../../shared/api/urls'
import { idOf, objectOf } from '../../../shared/api/wire'

export const verifyPosCashier = (body: { resourceId: string; sourceCashierId: string; credential: string; purpose: 'pos' }) => transportRequest<{ grant: string; expiresAt: string }>({
  url: AQSI_URLS.cashierAccessVerify, method: 'POST', body, noRetry: true,
  decode: (raw) => {
    const value = objectOf(raw, 'cashier access')
    const expiresAt = idOf(value.expiresAt, 'expiresAt')
    if (!Number.isFinite(Date.parse(expiresAt))) throw new Error('Некорректный срок подтверждения кассира')
    return { grant: idOf(value.grant, 'grant'), expiresAt }
  },
})
